import {
	UserAccountTypes,
	UserAccountUse,
	UserDepartments,
	UserNumberOfEmployees,
	UserOrganizationType,
} from "@/types/user";
import { z } from "zod";

export const emailSignUpSchema = z
	.object({
		email: z
			.string()
			.min(2, "Email must be at least 2 characters long.")
			.max(100, "Email cannot be more than 100 characters."),
		password: z.object({
			password: z
				.string()
				.min(6, "Password must be at least 6 characters long.")
				.max(50, "Password cannot be more than 50 characters."),
			confirmPassword: z
				.string()
				.min(6, "Confirm password must be at least 6 characters long.")
				.max(50, "Confirm password cannot be more than 50 characters."),
		}),
		firstName: z
			.string()
			.min(2, "First name must be at least 2 characters long.")
			.max(50, "First name cannot be more than 50 characters."),
		lastName: z
			.string()
			.min(2, "Last name must be at least 2 characters long.")
			.max(50, "Last name cannot be more than 50 characters."),
		number: z.string().optional(),
		accountType: z.nativeEnum(UserAccountTypes).optional(),
		website: z.string().optional(),
		avatar: z.string().optional(),
		company: z.string().min(0).max(50).optional(),
		designation: z.string().min(0).max(50).optional(),
		department: z.nativeEnum(UserDepartments).optional(),
		numberOfEmployees: z.nativeEnum(UserNumberOfEmployees).optional(),
		organizationType: z.nativeEnum(UserOrganizationType).optional(),
		//personal
		accountUse: z.nativeEnum(UserAccountUse).optional(),
		city: z
			.string()
			.min(2, "City name must be at least 2 characters long.")
			.max(100, "City name cannot be more than 100 characters.")
			.optional(),
		state: z
			.string()
			.min(2, "State name must be at least 2 characters long.")
			.max(50, "State name cannot be more than 50 characters.")
			.optional(),
		country: z
			.string()
			.min(2, "Country name must be at least 2 characters long.")
			.max(100, "Country name cannot be more than 50 characters.")
			.optional(),
	})
	.superRefine((v, ctx) => {
		if (v.password.password !== v.password.confirmPassword) {
			ctx.addIssue({
				message: "Passwords do not match",
				code: z.ZodIssueCode.custom,
				path: ["password.confirmPassword"],
			});
		}
	});

export type EmailSignUpFieldNames =
	| "accountType"
	| "website"
	| "avatar"
	| "company"
	| "designation"
	| "department"
	| "numberOfEmployees"
	| "organizationType"
	| "accountUse";

export type EmailSignUpSchema = z.infer<typeof emailSignUpSchema>;
